import { gql, 
     useMutation 
} from "@apollo/client";
import React, { ReactElement } from "react";
import { CreateCustomerTierMutationMutation, CreateCustomerTierMutationMutationVariables } from "../../../../../../schemaTypes";
import { NormalizedErrorMap } from "../../../../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../../../../utils/normalizeErrors";

export const createCustomerTierMutation = gql`
  mutation CreateCustomerTierMutation(
    $name: String!
    $multiplier: Int!
    $threshold: Int!
) {
    createCustomerTier(
        name: $name
        multiplier: $multiplier
        threshold: $threshold
    ) {
        errors {
            path
            message
        }
        message
    }
}
`;

interface Props {
  children: (
    data: {
      submitCreateCustomerTier: (
        values: CreateCustomerTierMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createCustomerTierData: any | null;
    }
  ) => ReactElement | null;
}

export const CreateCustomerTierController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateCustomerTierMutationMutation,
    CreateCustomerTierMutationMutationVariables
  >(createCustomerTierMutation);

  const submitCreateCustomerTier = async (values: CreateCustomerTierMutationMutationVariables) => {
    const { data: { createCustomerTier } }: any = await mutate({ variables: values });

    if (createCustomerTier?.errors) {
      return { error: normalizeErrors(createCustomerTier.errors), createCustomerTier: null };
    }

    return {
      error: null,
      createCustomerTier
    };
  };

  const message = data?.createCustomerTier?.message || null;

  return children({
    submitCreateCustomerTier,
    loading,
    error,
    message,
    createCustomerTierData: data,
  });
};